import * as React from 'react'

import Icon from 'components/Icon'
import { PAYMENT } from 'Icon/payment'
import { UI } from 'Icon/ui'
import './Dropdown.scss'

interface DropdownProps {
  name: string
  type?: string
  value?: number | number[]
  onChange?: (value: any, checked: boolean) => void
  condensed?: boolean
  children?: React.ReactNode | undefined
}

const Dropdown: React.FC<DropdownProps> = props => {
  const renderChildrenAsApi = () => {
    return React.Children.map(props.children, (child, index) => {
      const childElement = child as React.ReactElement<any>
      return React.cloneElement(childElement, {
        name: childElement.props.name || props.name,
        type: childElement.props.type || props.type,
        index: childElement.props.index || index,
        onChange: childElement.props.onChange || props.onChange,
      })
    })
  }

  return (
    <div className={`${props.condensed ? 'is-condensed' : ''}`}>
      {renderChildrenAsApi()}
    </div>
  )
}

interface DropdownItemProps {
  name?: string
  index?: number
  type?: string
  icon?: JSX.Element
  iconId?: string
  complete?: boolean
  warning?: boolean
  label: string | JSX.Element
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (value: any, checked: boolean) => void
  children?: React.ReactNode | undefined
}

const DropdownItem: React.FC<DropdownItemProps> = props => {
  const id = `${props.name}-${props.index}`
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      props.onChange(e.target.value, e.target.checked)
    }
  }
  const inputProps = {
    type: props.type,
    name: props.name,
    id,
    value: props.index,
    onChange: handleChange,
    defaultChecked: props.defaultChecked,
    checked: props.checked,
  }
  const classNames = [`srprs-dropdown`]
  if (props.complete) {
    classNames.push(`is-complete`)
  }
  if (props.warning) {
    classNames.push(`is-warning`)
  }

  let icon = null
  if (props.icon) {
    switch (props.icon) {
      case PAYMENT.klarna:
        icon = (
          <Icon
            icon={props.icon}
            id={props.iconId ? props.iconId : ''}
            enable-background="new -372 266.3 96 64"
            viewBox="-372 266.3 96 64"
          />
        )
        break
      default:
        icon = <Icon icon={props.icon} id={props.iconId ? props.iconId : ''} />
        break
    }
  }

  return (
    <div id={`srprs-dropdown-${id}`} className={classNames.join(` `)}>
      <input {...inputProps} />
      <header>
        {icon}
        <label htmlFor={id}>
          {props.label}
          <Icon icon={UI.triangleDown} />
        </label>
      </header>
      <div className="children">{props.children}</div>
    </div>
  )
}

Dropdown.defaultProps = {
  type: 'checkbox',
}

export { Dropdown, DropdownProps, DropdownItem }
